import store from '../store/index';

import CampaignMessageQueries from '../queries/campaignMessage.queries';
import ApiService from './ApiService';
import UtilsService from './UtilsService';

export enum CampaignViewTableType {
  SENT= 'SENT',
  CLICKED= 'CLICKED',
  REPLIED= 'REPLIED',
  FAILED= 'FAILED',
  OPTOUT= 'OPTOUT',
}

function getAllCampaignMessages(
  campaignId: string, page = 1, pageSize = 10, orderBy = '', orderDesc = false,
) {
  const retailerId = store.state.auth.currentUser.retailer.objectId;
  const query = CampaignMessageQueries.getAll(
    retailerId, campaignId, page, pageSize, orderBy, orderDesc,
  );
  return ApiService.get(UtilsService.buildFullPath(query)).then((res) => res.results);
}

function getAllCampaignMessagesByType(payload: {
  campaignId: string, type: CampaignViewTableType, page: 1, pageSize: 10, orderBy: '', orderDesc: false,
}) {
  const retailerId = store.state.auth.currentUser.retailer.objectId;
  const { campaignId, page, pageSize, orderBy, orderDesc, type } = payload;
  let query: any = {};
  let func = 'getAllSent';
  if (type === CampaignViewTableType.CLICKED) {
    func = 'getAllClicked';
  } else if (type === CampaignViewTableType.FAILED) {
    func = 'getAllFailures';
  } else if (type === CampaignViewTableType.REPLIED) {
    func = 'getAllReplied';
  } else if (type === CampaignViewTableType.SENT) {
    func = 'getAllSent';
  } else if (type === CampaignViewTableType.OPTOUT) {
    func = 'getAllOptOut';
  }
  query = (CampaignMessageQueries as any)[func](
    retailerId, campaignId, page, pageSize, orderBy, orderDesc,
  );
  return ApiService.get(UtilsService.buildFullPath(query));
}

function createCampaignMessage(CampaignMessageData: any) {
  return ApiService.post('/parse/classes/campaignMessages', CampaignMessageData);
}

function updateCampaignMessage(campaignMessageId: string, CampaignMessageData: any) {
  return ApiService.put(`/parse/classes/campaignMessages/${campaignMessageId}`, CampaignMessageData);
}

function deleteCampaignMessage(campaignMessageId: string) {
  return ApiService.del(`/parse/classes/campaignMessages/`, campaignMessageId);
}

const CampaignMessageService = {
  getAllCampaignMessages,
  createCampaignMessage,
  updateCampaignMessage,
  deleteCampaignMessage,
  getAllCampaignMessagesByType,
};

export default CampaignMessageService;
